import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BreadCrumb } from '../../models/shared.model';

@Component({
    selector: 'app-breadcrumb',
    standalone: false,
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbComponent {
    @Input({ required: true }) breadcrumbs: BreadCrumb[] = [];
    @Input({ required: true }) pageTitle!: string;
}
